import { produce } from 'immer';
export function createSliceWithImmer(config) {
    const immerActions = Object.fromEntries(Object.entries(config.actions).map(([actionKey, action]) => [
        actionKey,
        (...args) => (prev) => produce(prev, (draft) => action(...args)(draft)),
    ]));
    return {
        ...config,
        actions: immerActions,
    };
}
